module.exports = __webpack_public_path__ + "imgs/gosPartnersLogo5.eb1c4ca9.webp";